module.exports = __webpack_public_path__ + "img/login_bg.b9e15924.jpg";